import React from 'react';

type LoadingContextProps = {
	setLoading: (loading: boolean) => void;
};

export const LoandingContext = React.createContext<LoadingContextProps>({
	setLoading: () => null,
});
